var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"pa-2 d-flex flex-column justify-end",staticStyle:{"position":"relative"},attrs:{"color":"transparent","elevation":"0","tile":""}},[(_vm.graphIsReady)?_c('apex-chart',{attrs:{"options":_vm.options,"series":_vm.series,"height":"400","type":"area"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }